export default __webpack_public_path__ + "static/media/appleLogo.440b0d23.png";